import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudDownload"><Path d="M15.5 19.5H18C20.4853 19.5 22.5 17.4853 22.5 15C22.5 12.6779 20.7411 10.7666 18.483 10.5256C18.24 7.15724 15.4303 4.5 12 4.5C9.25838 4.5 6.91321 6.19737 5.95801 8.59857C3.4187 9.08552 1.5 11.3187 1.5 14C1.5 17.0376 3.96243 19.5 7 19.5H8.5M12 11.5V18.5M9.5 16.75L12 19.25L14.5 16.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudDownload;
